module.exports = __webpack_public_path__ + "img/logos/loom-logo-5fbeb2a2c94575e6681b148ee1ffdfb5.png";